import { Route, Routes, useLocation } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./App.css";

import HomePage from "./pages/HomePage";
import Header from "./pages/Header";
import ContactPage from "./pages/ContactPage";
import CareerPage from "./pages/CareerPage";
import AboutPage from "./pages/AboutPage";
import BlogDetailsPage from "./pages/BlogDetailsPage";
import Footer from "./pages/Footer";
import ServicesPage from "./pages/ServicesPage";
import WebDevelopment from "./customComponent/WebdevelopmentPage";
import SMSMarketingServices from "./customComponent/SMSservicesPage";
import AppDevelopment from "./customComponent/AppdevelopmentPage";
import StaffingServices from "./customComponent/StaffingPage";
import ScrollToTop from "./customComponent/ScrollToTop";
import NotFoundPage from "./pages/NotFoundPage";
import ApplyCareer from "./pages/ApplyCareer";
import PageMetadata from "./pages/PageMetadata";
import WhatsAppFloatingButton from "./components/WhatsAppFloatingButton";
import SocialSidebar from "./customComponent/SocialSidebar";
import LoginPage from "./pages/LoginPage";
import DashBoardLayoutPage from "./pages/DashBoardLayoutPage";
import RegisterPage from "./pages/RegisterPage";
import PrivateRoute from "./components/PrivateRoute";
import BlogPage from "./pages/BlogPage";

function App() {
  const location = useLocation();

  // Paths where you don't want Header, Footer, and SocialSidebar
  const noNavFooterPaths = ["/login", "/dashboard", "/register"];
  const noWhatsAppButtonPaths = ["/login", "/dashboard", "/register"];

  const showNavFooter = !noNavFooterPaths.includes(location.pathname);
  const showWhatsAppButton = !noWhatsAppButtonPaths.includes(location.pathname);



  return (
    <>
      <PageMetadata />
      {showNavFooter && <SocialSidebar />}
      {showWhatsAppButton && <WhatsAppFloatingButton />}
      <ScrollToTop />

      {showNavFooter && <Header />}

      <Routes>
        <Route exact path="/" element={<HomePage />} />
        <Route path="/about-glowtech-solutions" element={<AboutPage />} />
        <Route path="/glowtech-services" element={<ServicesPage />} />
        <Route
          path="/aI-based-web-development-services"
          element={<WebDevelopment />}
        />
        <Route
          path="/aI-based-app-development-services"
          element={<AppDevelopment />}
        />
        <Route
          path="/aI-integrated-staffing-solutions"
          element={<StaffingServices />}
        />
        <Route
          path="/sms-whatsapp-api-solutions"
          element={<SMSMarketingServices />}
        />
        <Route path="/glowtech-blogs" element={<BlogPage />} />
        <Route path="/glowtech-blogs/:slug" element={<BlogDetailsPage />} />
        <Route path="/glowtech-careers" element={<CareerPage />} />
        <Route path="/glowtech-careers/:id" element={<ApplyCareer />} />
        <Route path="/contact-glowtech-solutions" element={<ContactPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/register"
          element={
            <PrivateRoute>
              <RegisterPage />
            </PrivateRoute>
          }
        />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <DashBoardLayoutPage />
            </PrivateRoute>
          }
        />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>

      {showNavFooter && <Footer />}
    </>
  );
}

export default App;
